import { createContext, useState } from "react";
import { getSession, isPersistent } from "../common/utils/tokenStorage";

interface AuthProps {
  children: JSX.Element;
}

const AuthContext = createContext<any>({});

export const AuthProvider = ({ children }: AuthProps) => {
  const shouldPersist = isPersistent();
  // Seeded synchronously, not in an effect: a route guard rendering before hydration
  // would redirect an authenticated user to /login. Safe because the app is
  // browser-only (Vite, no SSR) — see docs/AI_HANDOFF.md.
  const [auth, setAuth] = useState<any>(() => getSession() ?? {});
  const [persist, setPersist] = useState(shouldPersist);
  const [goBack, setGoBack] = useState(false);

  return (
    <AuthContext.Provider
      value={{ auth, setAuth, persist, setPersist, goBack, setGoBack }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
